import { COOKIE_DOMAIN } from "../const";
import { clearAuthCookies, getCookie, setCookie } from "./cookies";
import { assertSafeReturnUrl, buildLoginRedirectUrl } from "./return-url";
export const validateReturnUrl = (returnUrl, baseUrl) => {
    return assertSafeReturnUrl(returnUrl, baseUrl);
};
export const buildLoginUrl = ({ userCenterUrl, locale, action = "login", returnUrl, }) => {
    return buildLoginRedirectUrl(userCenterUrl, locale, action, returnUrl);
};
export const setAuthCookie = (config, token, options = {}) => {
    setCookie(options.temporary ? config.temporaryCookieName : config.cookieName, token, {
        domain: COOKIE_DOMAIN,
        days: options.remember ? 30 : undefined,
    });
};
export const clearAuthCookie = (config) => {
    clearAuthCookies(config.cookieName, config.temporaryCookieName, COOKIE_DOMAIN);
};
export const getAuthToken = (config) => {
    return getCookie(config.cookieName);
};
//# sourceMappingURL=session.js.map